@if (datesUI) {
  <swiper-container #swiper ushSwiperElement [config]="swiperConfig" init="false">
    @for (date of datesUI | keyvalue; track date; let i = $index) {
      <swiper-slide>
        <a
          class="date-item {{ clickedItem === i ? 'active' : '' }}"
          (click)="dateClicked(i, date?.key)"
          (keyup)="dateKeyup($event, i, date?.key)"
          [innerHTML]="formatDateInLines(date?.value | titlecase) | safe: 'html'"
          tabindex="0"
        >
        </a>
      </swiper-slide>
    }
  </swiper-container>
} @else {
  <p [attr.data-translate]="'dates-carousel.noDatesAvailable'">
    {{ 'dates-carousel.noDatesAvailable' | translate: { placeholder: 'No dates available' } }}
  </p>
}
